import './AuthRequired.sass';
import '../AuthPopover/AuthPopover.sass';

import React, { useEffect } from 'react';

import { Auth } from '$shared/components';
import { useTranslator } from '$hooks';
import { ScrollView } from '$uikit';
import { useSelector } from 'react-redux';
import { authSelector } from '$store/auth';
import { useRoute } from 'react-router5';
import router from '$navigation/router';

export function AuthRequired({ skipRedirect = false }: { skipRedirect?: boolean }) {
  const t = useTranslator();
  const { isLogged } = useSelector(authSelector);
  const { route } = useRoute();

  useEffect(() => {
    if (isLogged && !skipRedirect) {
      let nextUrl = '/feed';
      if (
        route.params.target &&
        (!route.params.target.match('registration|auth|quiz') ||
          route.params.target.match('author|oauth'))
      ) {
        const parsed = router.matchUrl(route.params.target);
        if (parsed && parsed.path !== '/') {
          nextUrl = parsed.path;
        }
      }

      location.href = nextUrl;
    }
  }, [isLogged]);

  return (
    <ScrollView>
      <div className="AuthRequired">
        <div className="AuthRequired__title">{t('auth_required_title')}</div>
        <div className="AuthRequired__caption">{t('auth_required_caption')}</div>
        <div className="AuthRequired__form">
          <Auth />
        </div>
      </div>
    </ScrollView>
  );
}
